/**
 * Account sign-in panel hint (22 Oct 2026, owner; ported from Swag Chic's sc-account-hint.js): "New here? Enter your email and we'll create your account." under
 * the email box of the header's sign-in panel. With Shopify's customer accounts, entering an email the first time
 * creates the account, but the panel only said "Sign in or create account", so shoppers looked for a register link.
 *
 * The panel is Shopify's <shopify-account> component, with no slot for extra text. Its shadow roots are open, so the
 * line goes in after the email form. If Shopify changes the panel's markup, nothing is found and nothing happens.
 */
const HINT = 'New here? Enter your email and we’ll create your account.';

/** @returns {Element | null} the email form inside Shopify's sign-in panel */
function emailForm() {
  const account = document.querySelector('shopify-account')?.shadowRoot;
  const loginForm = account?.querySelector('shopify-login-form');
  return loginForm?.shadowRoot?.querySelector('form.login-form__email-form') ?? null;
}

function addHint() {
  const form = emailForm();
  if (!form || form.parentNode?.querySelector('.mlb-new-here')) return Boolean(form);
  const hint = document.createElement('p');
  hint.className = 'mlb-new-here';
  hint.textContent = HINT;
  hint.style.cssText = 'margin:10px 2px 2px; font-size:13px; line-height:1.45; opacity:0.78;';
  form.after(hint);
  return true;
}

/** The panel is built when it opens, so look for it for a short while after a tap on the account button */
function watch() {
  let tries = 0;
  const timer = setInterval(() => {
    if (addHint() || ++tries > 30) clearInterval(timer);
  }, 100);
}

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.account-button, shopify-account')) watch();
});
